import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { CloseWindow } from '@platform-frontend/util';

@UntilDestroy()
@Component({
  selector: 'yat-cancel-confirmation',
  templateUrl: './cancel-confirmation.component.html',
  styleUrls: ['./cancel-confirmation.component.scss']
})
export class CancelConfirmationComponent {
  constructor(private store: Store) {}

  close(): void {
    this.store.dispatch(new CloseWindow());
  }
}
